module.exports = __webpack_public_path__ + "img/naughtybear.0f4db120.png";